/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteOtherSystemSourceInsightInput
 */
export interface DeleteOtherSystemSourceInsightInput {
    /**
     * 
     * @type {string}
     * @memberof DeleteOtherSystemSourceInsightInput
     */
    id?: string;
}

/**
 * Check if a given object implements the DeleteOtherSystemSourceInsightInput interface.
 */
export function instanceOfDeleteOtherSystemSourceInsightInput(value: object): value is DeleteOtherSystemSourceInsightInput {
    return true;
}

export function DeleteOtherSystemSourceInsightInputFromJSON(json: any): DeleteOtherSystemSourceInsightInput {
    return DeleteOtherSystemSourceInsightInputFromJSONTyped(json, false);
}

export function DeleteOtherSystemSourceInsightInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteOtherSystemSourceInsightInput {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function DeleteOtherSystemSourceInsightInputToJSON(json: any): DeleteOtherSystemSourceInsightInput {
    return DeleteOtherSystemSourceInsightInputToJSONTyped(json, false);
}

export function DeleteOtherSystemSourceInsightInputToJSONTyped(value?: DeleteOtherSystemSourceInsightInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

